export default __webpack_public_path__ + "static/media/eb-pro-blk-1.35a1d96b.png";